import React, { Component } from "react";
import BaseComponent from "../BaseComponent.js";
import styled from "styled-components";
import nota from "../Global/nota.guidelines.json";
import { elementMatchesAny } from "../Global/tools.js";
import { Popper, Reference, Manager } from "react-popper";

import Type from "./../Global/Typography.js";
import NanoFlex from "./../Global/NanoFlex";
import Image from "./../Nano/Image.js";
import BiggerThumbHover from "./../Micro/BiggerThumbHover.js";

const multiple = nota.global.multiple;

const StyledCardBlock = styled.div`
  pointer-events: ${(props) => (props.disabled ? "none" : "unset")};
  margin: ${multiple / 2 + "px"}; /* 4px */
  cursor: pointer;
  position: relative;
  .cardBlockWrapper {
    width: 100%;
    padding: ${multiple + "px"} 0px;
    min-height: 60px;
    justify-content: flex-start;
    h5,
    p {
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  &:hover {
    .wrapperCard {
      .imgWrapper {
        opacity: 0.7;
      }
    }
  }

  /* .tooltipContainer {
    position: relative;
  } */
  .popUpContainer {
    z-index: 99;
  }
`;

class CardBlock extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      isVisible: true,
      selected: this.props.selected ? this.props.selected : false,
      isTooltipOpen: false,
    };

    this.container = React.createRef();
    this.preventOnSelectedChange = false;

    this.isMouseOver = false;
  }

  componentDidMount() {
    super.componentDidMount();
    const lazyLoad = (target) => {
      const io = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting !== this.state.isVisible) {
              this.setState({ isVisible: entry.isIntersecting });
            }
          });
        },
        { rootMargin: "250px" }
      );
      io.observe(target);
    };
    lazyLoad(this.container.current);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.selected !== prevProps.selected) {
      this.preventOnSelectedChange = true;
      this.setState({ selected: this.props.selected ? this.props.selected : false }, () => {
        this.preventOnSelectedChange = false;
      });
    }

    if (prevState.selected !== this.state.selected && this.props.onSelectedChange && !this.preventOnSelectedChange) {
      this.props.onSelectedChange(this.state.selected);
    }
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  onCardClick = (e) => {
    if (elementMatchesAny(e.target, [".selectThumbContainer"])) return;
    window.open(`/card/${this.props.id}`, "_blank");
  };

  onCardMouseDown = (e) => {
    if (e.button == 1) {
      //middle mouse button click
      this.onCardClick(e);
    }
  };

  onSelectClick = (e) => {
    this.setState({ selected: !this.state.selected });
  };

  getSecondaryField = () => {
    switch (this.props.type) {
      case "SubGenre":
        return this.props.subGenre;
      default:
        return this.props.countryAndChannel;
    }
  };

  render() {
    var card = (
      <NanoFlex className="wrapperCard" flexDirection={"column"} justifyContent={"space-between"}>
        <Image
          imageUrl={this.props.image}
          alt={this.props.title}
          performanceColor={this.props.performanceColor}
          selectable={this.props.selectable}
          onSelectClick={this.onSelectClick}
          selected={this.state.selected}
          isNotaSelection={this.props.isNotaSelection}
          hideSelection={this.props.hideSelection}
          isNew={this.props.isNew}
        />
        <NanoFlex className="cardBlockWrapper" flexDirection={"column"} alignItems={"flex-start"}>
          <Type.h5 title={this.props.title}>
            <b>{this.props.title}</b>
          </Type.h5>
          <Type.p>
            <b>{this.getSecondaryField()}</b>
          </Type.p>
          <Type.p>{this.props.date}</Type.p>
        </NanoFlex>
      </NanoFlex>
    );
    return (
      <StyledCardBlock className="cardBlock" style={this.state.isVisible ? null : { visibility: "hidden" }} size={this.props.size} onClick={this.onCardClick} onMouseDown={this.onCardMouseDown} disabled={this.props.id === -1} ref={this.container}>
        {this.props.hasBiggerThumb && !this._isMobile && (
          <div
            onMouseEnter={() => {
              this.isMouseOver = true;
              //Delay Tooltip Show
              setTimeout(() => {
                if (this.isMouseOver == true) {
                  this.setState({ isTooltipOpen: true });
                }
              }, 1000);
            }}
            onMouseLeave={() => {
              this.isMouseOver = false;
              //Delay Tooltip Hide
              setTimeout(() => {
                if (this.isMouseOver == false) {
                  this.setState({ isTooltipOpen: false });
                }
              }, 500);
            }}>
            <Manager>
              <Reference>
                {(targetProps) => {
                  return <div ref={targetProps.ref}>{card}</div>;
                }}
              </Reference>
              {this.state.isTooltipOpen && (
                <Popper placement={"bottom"}>
                  {({ ref, style, placement, arrowProps }) => (
                    <div className="popUpContainer" ref={ref} style={style} data-placement={placement}>
                      <BiggerThumbHover id={this.props.id} isVisible={this.state.isTooltipOpen} />
                    </div>
                  )}
                </Popper>
              )}
            </Manager>
          </div>
        )}
        {(!this.props.hasBiggerThumb || this._isMobile) && card}
      </StyledCardBlock>
    );
  }
}

// Set default props
CardBlock.defaultProps = {
  id: 0,
  title: "", // 'Programm Title'
  countryAndChannel: "", // 'Country - Channel'
  date: "", // '01 Jan 2000'
  image: null,
  size: "xxs",
};

export default CardBlock;

// --- // Documentation // --- //
/*
import CardBlock from './../Nano/CardBlock.js';

<CardBlock
    id={0}
    title={'Programm Title'}
    countryAndChannel={'Country - Channel'}
    date={'01 Jan 2000'}
    image={null}
    performanceColor={null}
    size={'xxs'}
/>
*/
